import { CheckListTypes } from '~/redux/apis/types'

export const getChecklistProgress = (checklist: CheckListTypes | null) => {
  if (checklist) {
    const total = Object.keys(checklist).length - 1
    let completed = Object.values(checklist).filter((item) => item.isCompleted).length

    completed = Math.max(checklist['completedCheckList'].isCompleted ? completed - 1 : completed, 0)

    return { total, completed }
  }

  return { total: 1, completed: 0 }
}

export const isChestCompleted = (checklist: CheckListTypes | null): boolean => {
  if (checklist) {
    const completed = checklist['completedCheckList'].isCompleted

    return completed
  }

  return false
}
